import axiosInstance from "../services/axiosInstance";
import * as Endpoints from "../entities/Endpoints";

export const fetchClientInformation = async ({ clientId, coachId }) => {
  try {
    const response = await axiosInstance.get(
      `${Endpoints.GET_CLIENT_INFORMATION}/${clientId}/${coachId}`
    );

    return response.data;
  } catch (error) {
    throw error?.data?.message || "Something went wrong.";
  }
};
export const updatetClientInformation = async (payload) => {
  try {
    const response = await axiosInstance.post(
      Endpoints.POST_CLIENT_INFORMATION,
      payload
    );

    return response.data;
  } catch (error) {
    throw error?.data?.message || "Something went wrong.";
  }
};
